import api from "@/lib/api-client";
import type {
  ITab,
  ICreateTab,
  IUpdateTab,
  IParsedSpec,
} from "../types/tab.types.ts";

export async function listTabs(spaceId: string): Promise<ITab[]> {
  const res = await api.post<ITab[]>("/tabs/list", { spaceId });
  return res.data;
}

export async function createTab(input: ICreateTab): Promise<ITab> {
  const res = await api.post<ITab>("/tabs/create", input);
  return res.data;
}

export async function updateTab(input: IUpdateTab): Promise<ITab> {
  const res = await api.post<ITab>("/tabs/update", input);
  return res.data;
}

export async function deleteTab(tabId: string): Promise<void> {
  await api.post("/tabs/delete", { tabId });
}

/** Validate raw JSON/YAML and return parsed OpenAPI spec + summary. */
export async function parseTabSpec(content: string): Promise<IParsedSpec> {
  const res = await api.post<IParsedSpec>("/tabs/parse-spec", { content });
  return res.data;
}

/**
 * Server-side preview-fetch from a URL. Returns the same shape as
 * parseTabSpec but does the GET on the backend (so the browser doesn't
 * need to deal with CORS for upstream raw-content servers).
 */
export async function fetchTabSpecFromUrl(
  url: string,
  auth?: string,
): Promise<IParsedSpec> {
  const res = await api.post<IParsedSpec>("/tabs/fetch-spec", {
    url,
    auth: auth || undefined,
  });
  return res.data;
}

export async function pullTabSpec(tabId: string): Promise<ITab> {
  const res = await api.post<ITab>("/tabs/pull-spec", { tabId });
  return res.data;
}

export async function publishTabSpec(tabId: string): Promise<ITab> {
  const res = await api.post<ITab>("/tabs/publish", { tabId });
  return res.data;
}

export interface ISpecDiff {
  firstPublish: boolean;
  added: string[];
  removed: string[];
  changed: string[];
  infoChanged: boolean;
}

export async function diffTabSpec(tabId: string): Promise<ISpecDiff> {
  const res = await api.post<ISpecDiff>("/tabs/diff", { tabId });
  return res.data;
}
